function addWistiaScript(src) {
  if ([...document.scripts].some((s) => s.src === src)) {
    return;
  }

  const script = document.createElement('script');
  script.src = src;
  script.async = true;
  const firstScriptTag = document.getElementsByTagName('script')[0];
  if (firstScriptTag && firstScriptTag.parentNode) {
    firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
    return;
  }

  document.head.appendChild(script);
}

const WISTIA_ID_PATTERN = /^[a-zA-Z0-9]+$/;

function getWistiaIds() {
  const ids = new Set();

  document.querySelectorAll('[data-wistia-video-id]').forEach((element) => {
    const id = element.getAttribute('data-wistia-video-id')?.trim();
    if (id && WISTIA_ID_PATTERN.test(id)) {
      ids.add(id);
    }
  });

  document.querySelectorAll('[class*="wistia_async_"]').forEach((element) => {
    element.classList.forEach((className) => {
      if (className.startsWith('wistia_async_')) {
        const id = className.replace('wistia_async_', '').trim();
        if (id && WISTIA_ID_PATTERN.test(id)) {
          ids.add(id);
        }
      }
    });
  });

  return Array.from(ids);
}

function initWistiaEmbeds() {
  const wistiaIds = getWistiaIds();
  if (wistiaIds.length === 0) {
    return;
  }

  window.__mheLoadedWistiaMediaIds = window.__mheLoadedWistiaMediaIds || new Set();

  addWistiaScript('https://fast.wistia.com/assets/external/E-v1.js');

  wistiaIds.forEach((id) => {
    if (window.__mheLoadedWistiaMediaIds.has(id)) {
      return;
    }

    addWistiaScript(`https://fast.wistia.com/embed/medias/${id}.jsonp`);
    window.__mheLoadedWistiaMediaIds.add(id);
  });

  if (!window.hasAlreadyLoadedWistia) {
    window.hasAlreadyLoadedWistia = true;
  }
}

function scheduleWistiaInit() {
  if (window.__mheWistiaInitScheduled) {
    return;
  }

  window.__mheWistiaInitScheduled = true;

  requestAnimationFrame(() => {
    window.__mheWistiaInitScheduled = false;
    initWistiaEmbeds();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initWistiaEmbeds();

  const observer = new MutationObserver(() => {
    scheduleWistiaInit();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
